<app-header [title]="title" [subtitle]="subtitle"></app-header>
<main>
  <div class="containero">


    <aside>
      <form (ngSubmit)="showLocation()">
        <div>
          <label for="zipcode" >Podaj kod pocztowy</label>
          <input [ngModelOptions]="{standalone: true}" [(ngModel)]="zipcode" type="search" placeholder="__-___"
                 maxlength="6" pattern="[0-9][0-9]-[0-9][0-9][0-9]" title="Kod pocztowy" (ngModelChange)="onZipCodeChange()">
        </div>
        <div>
          <label for="city" >Wpisz adres</label>
          <input [ngModelOptions]="{standalone: true}" [(ngModel)]="city" type="search" placeholder="ulica, miasto"
             >
        </div>
        <button class="btn btn-primary btn-sm" type="submit">
          <span class="content" >Szukaj</span>
        </button>
        <button class="btn btn-primary btn-sm" type="button">
          <span class="content"  (click)="setCurrentLocation()">Aktualna pozycja</span>
        </button>
      </form>
      <hr>
      <h2  >Dostępność w Twojej okolicy:</h2>
      <ol>
        <li *ngFor="let marker of project.closestSellers"><b>{{marker.company}}</b>, {{marker.address}},<br>
          {{marker.zipcode}} {{marker.city}}</li>
      </ol>
    </aside>
    <div class="maps">

      <google-map #mapRef height="600px" width="800px" [options]="options" [center]="center" [zoom]="zoom">



        @for (marker of sprzedawcy; track location; let index = $index) {
        <map-advanced-marker
          #markerElem="mapAdvancedMarker"
          [position]="{ lat: marker.location.lat, lng: marker.location.lng }"
    [content]="location.content"
    [title]="'<h3> ' + marker.company + '</h3><p>' + marker.address + '<BR>' + marker.zipcode + ' ' + marker.city + '</p><p><b>Kontakt:</b> <br>' + marker.contacts[marker.contacts.length-1].firstname + ' ' + marker.contacts[marker.contacts.length-1].lastname
    + '<BR>tel: ' + marker.contacts[0].phone + '<BR></p><b>Strefa koloru Knauf:</b>' +

    marker.palettes



    + '
<p>Dystans: ' + marker.distance + 'km</p>'
    "
    (mapClick)="onMarkerClick(markerElem)"
  />
        }
        <map-info-window #infoWindow></map-info-window>
      </google-map>

<!--      <agm-map [latitude]="location?.lat" [longitude]="location?.lng" [zoom]="zoom">-->
<!--        <agm-marker [latitude]="location?.lat" [longitude]="location?.lng" [iconUrl]="{ url : 'https://raw.githubusercontent.com/Concept211/Google-Maps-Markers/master/images/marker_green.png' }">-->
<!--        </agm-marker>-->
<!--        <agm-marker *ngFor="let marker of sprzedawcy" [latitude]="marker.location.lat"-->
<!--          [longitude]="marker.location.lng">-->
<!--          <agm-info-window>-->
<!--            <h3>{{marker.company}}</h3>-->
<!--            <p>{{marker.address}}<br>{{marker.zipcode}} {{marker.city}}</p>-->
<!--            <p><b>Kontakt:</b> <br>-->
<!--              {{marker.contacts[marker.contacts.length-1].firstname}}-->
<!--              {{marker.contacts[marker.contacts.length-1].lastname}}<br>-->
<!--              tel: {{marker.contacts[0].phone}}<br></p>-->
<!--            <b>Strefa koloru Knauf:</b>-->
<!--            <div *ngFor="let pal of marker.palettes">{{pal}} </div>-->
<!--            <p>Dystans: {{marker.distance}}km</p>-->

<!--          </agm-info-window>-->
<!--        </agm-marker>-->
<!--      </agm-map>-->
    </div>
  </div>
</main>
<app-footer [prev]="prev" [next]="next"></app-footer>
